export var Role;
(function (Role) {
    Role["ADMIN"] = "ADMIN";
    Role["STAFF"] = "STAFF";
    Role["CLIENT"] = "CLIENT";
    Role["SURVEYOR"] = "SURVEYOR";
    Role["CONTRACTOR"] = "CONTRACTOR";
    Role["SUBCONTRACTOR"] = "SUBCONTRACTOR";
})(Role || (Role = {}));
export const DEFAULT_ADMIN_ACCESS = {
    all: true,
    sites: true,
    quotes: true,
    templates: true,
    jobs: true,
    contacts: true,
    estimating: true,
    costSettings: true,
    forms: true,
    userManagement: true,
};
export const DEFAULT_STAFF_ACCESS = {
    all: false,
    sites: true,
    quotes: true,
    templates: false,
    jobs: true,
    contacts: true,
    estimating: true,
    costSettings: false,
    forms: false,
    userManagement: false,
};
/**
 * Maps contact login API payload to User for use in AuthContext and app-wide.
 */
export function mapAuthContactToUser(contact) {
    const name = [contact.firstName, contact.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
    const role = Object.values(Role).includes(contact.type)
        ? contact.type
        : Role.CLIENT;
    return {
        id: contact.id,
        email: contact.email,
        firstName: contact.firstName,
        lastName: contact.lastName,
        name: name || undefined,
        role,
    };
}
